import React from 'react';
import { Link } from 'react-router-dom';

import Panel from '../../components/Panel/Panel';

import FaceWithMonocle56 from '../../icons/FaceWithMonocle56';

import styles from '../PaymentDone/payment-success.scss';

export default function NotFound() {
    React.useEffect(() => {
        window.location.assign('/404.html');
    }, []);

    return (
        <Panel
            contentStyles={{
                background: '#F4F4F6',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            fill={true}
        >
            <div className={styles.wrapper}>
                <div style={{ width: 56, margin: '0 auto' }}>
                    <FaceWithMonocle56 />
                </div>
                <h1 className={styles.title}>Здесь ничего нет.</h1>
                <p className={styles.description}>
                    Нам нечего отобразить по этой ссылке.
                    <br />
                    Попробуйте начать с <Link to="/">главной</Link>.
                </p>
            </div>
        </Panel>
    );
}
